export enum DOSSIER_STATUS {
    OPEN="OPEN",
    REOPENED="REOPENED",
    CANCELLED="CANCELLED",
    FINCLOSED="FINCLOSED",
    OPCLOSED="OPCLOSED"
}

export const DOSSIERSTATUS=[
    {KEY: "DOSSIER.DOSSIER_HEADER.OPEN"}, 
    {KEY: "DOSSIER.DOSSIER_HEADER.REOPENED"}, 
    {KEY: "DOSSIER.DOSSIER_HEADER.CANCELLED"}, 
    {KEY: "DOSSIER.DOSSIER_HEADER.FINCLOSED"}, 
    {KEY: "DOSSIER.DOSSIER_HEADER.OPCLOSED"}
]